import { render, staticRenderFns } from "./DomicilioCambioComponent.vue?vue&type=template&id=6c8cc90a&scoped=true"
import script from "./DomicilioCambioComponent.vue?vue&type=script&lang=js"
export * from "./DomicilioCambioComponent.vue?vue&type=script&lang=js"
import style0 from "./DomicilioCambioComponent.vue?vue&type=style&index=0&id=6c8cc90a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8cc90a",
  null
  
)

export default component.exports